(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2okK5", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1bdde9abb9c4bc7f$export$6503ec6e8aabbaf; }, function (v) { return $1bdde9abb9c4bc7f$export$6503ec6e8aabbaf = v; });
var $1bdde9abb9c4bc7f$export$6503ec6e8aabbaf;
var $1bdde9abb9c4bc7f$export$f7ad0328861e2f03;
"use strict";
var $1bdde9abb9c4bc7f$var$mapping = new Map();
function $1bdde9abb9c4bc7f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1bdde9abb9c4bc7f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1bdde9abb9c4bc7f$var$resolve(id) {
    var resolved = $1bdde9abb9c4bc7f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1bdde9abb9c4bc7f$export$6503ec6e8aabbaf = $1bdde9abb9c4bc7f$var$register;
$1bdde9abb9c4bc7f$export$f7ad0328861e2f03 = $1bdde9abb9c4bc7f$var$resolve;

});

parcelRegister("1BDrg", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $12b7d6d85ca5dcbb$export$bdfd709ae4826697; }, function (v) { return $12b7d6d85ca5dcbb$export$bdfd709ae4826697 = v; });
var $12b7d6d85ca5dcbb$export$bdfd709ae4826697;
var $12b7d6d85ca5dcbb$export$c9e73fbda7da57b6;
var $12b7d6d85ca5dcbb$export$5a759dc7a1cfb72a;
"use strict";
var $12b7d6d85ca5dcbb$var$bundleURL = {};
function $12b7d6d85ca5dcbb$var$getBundleURLCached(id) {
    var value = $12b7d6d85ca5dcbb$var$bundleURL[id];
    if (!value) {
        value = $12b7d6d85ca5dcbb$var$getBundleURL();
        $12b7d6d85ca5dcbb$var$bundleURL[id] = value;
    }
    return value;
}
function $12b7d6d85ca5dcbb$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $12b7d6d85ca5dcbb$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $12b7d6d85ca5dcbb$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $12b7d6d85ca5dcbb$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$12b7d6d85ca5dcbb$export$bdfd709ae4826697 = $12b7d6d85ca5dcbb$var$getBundleURLCached;
$12b7d6d85ca5dcbb$export$c9e73fbda7da57b6 = $12b7d6d85ca5dcbb$var$getBaseURL;
$12b7d6d85ca5dcbb$export$5a759dc7a1cfb72a = $12b7d6d85ca5dcbb$var$getOrigin;

});

var $9470c0674bd5df40$exports = {};


(parcelRequire("2okK5")).register((parcelRequire("1BDrg")).getBundleURL("bVHal"), JSON.parse('["bVHal","index.292ee6dc.js","3aSbc","icons.c14567a0.svg"]'));

})();
//# sourceMappingURL=index.runtime.ee4bfbbc.js.map
